export interface ValidationOptions {
    required?: boolean;
    minLength?: number;
    maxLength?: number;
    pattern?: RegExp;
    min?: number;
    max?: number;
    type: string;
}

export function getValidity(input: HTMLInputElement, customError: boolean = false): ValidityState {
    const validity = {
        valid: customError ? false : input?.validity.valid,
        customError,
        badInput: input?.validity.badInput,
        patternMismatch: input?.validity.patternMismatch,
        rangeOverflow: input?.validity.rangeOverflow,
        rangeUnderflow: input?.validity.rangeUnderflow,
        stepMismatch: input?.validity.stepMismatch,
        tooLong: input?.validity.tooLong,
        tooShort: input?.validity.tooShort,
        typeMismatch: input?.validity.typeMismatch,
        valueMissing: input?.validity.valueMissing
    };

    return validity;
}
